import startCase from 'lodash-es/startCase';
import enFortune from '../data/lang/en-fortune.json';
import en from '../data/lang/en.json';
import idFortune from '../data/lang/id-fortune.json';
import id from '../data/lang/id.json';
import { reportFunctionError } from './sentry';
import { storage } from './Storage';

export type SupportedLocale = 'en' | 'id';

export const initTranslation = () => {
  storage.set('idFortune', idFortune);
  storage.set('enFortune', enFortune);
};

export const getLanguage = () => {
  return storage.get('lang') ?? 'id';
};

const get = (json: Record<string, any>, key: string): string | undefined => {
  if (Object.prototype.hasOwnProperty.call(json, key)) {
    return json[key];
  }

  return undefined;
};

export const translator = (
  locale: SupportedLocale,
  key: string,
): string | undefined => {
  const idFile = id;
  const enFile = en;

  switch (locale) {
    case 'id':
      return get(idFile, key);
    default:
      return get(enFile, key);
  }
};
/**
 * @deprecated for page or feature's use, use getTranslation from useTranslate instead
 */
export const translate = (
  locale: SupportedLocale,
  key: string | null | undefined,
): string => {
  if (key === null || key === undefined || key == '') return ``;

  const result = translator(locale, key);

  if (result === undefined) {
    // eslint-disable-next-line no-console
    console.error(`Translation with ${key} key not found`);
    reportFunctionError({
      name: 'translate',
      message: `Translation with ${key} key not found`,
      domain: 'all',
      parentName: 'Translator',
    });

    const prefixesToRemove = ['common_', 'common_txProduct'];

    // Create a regular expression pattern by joining the prefixes with '|'
    const pattern = new RegExp(
      prefixesToRemove.map(prefix => `${prefix}\\w+`).join('|'),
      'g',
    );

    //  fallback to the key without underscore
    return (
      translator('en', key) ??
      startCase(key.replace(pattern, '').replace(/_/g, ' ').toLowerCase())
    );
  }

  return result;
};

/**
 * WARNING This function load from localStorage. It may be possible to not get latest setting.
 * If you want to get the realtime capability use getTranslation from useTranslate hooks
 */
export const getTranslation = (key: string, setLang?: string): string => {
  let lang = getLanguage();

  if (setLang) {
    lang = setLang;
  }
  return translate(lang, key);
};

export const getComponentTranslation = (key: string): string => {
  const lang = getLanguage();
  return translate(lang, key);
};
